import styled from 'styled-components'

type Props = {
	isInline?: boolean
}

// Source: https://github.com/adobe/react-spectrum/blob/a2146aa2eb9cc28f4d90c8f520e6be5ff90471c4/packages/%40react-aria/visually-hidden/src/VisuallyHidden.tsx#L33-L42

/**
 * Simplified version of hidden element from @react-aria/visually-hidden,
 * without all the state, focus etc., but with the same styles.
 */
export const VisuallyHidden = styled.div.attrs({
	role: 'none',
})<Props>`
	border: 0;
	/* stylelint-disable-next-line property-no-deprecated */
	clip: rect(0 0 0 0);
	clip-path: inset(50%);
	overflow: hidden;
	padding: 0;
	position: absolute;
	white-space: nowrap;
	font-size: 1px;

	display: ${({ isInline }) => (isInline ? 'inline-block' : 'block')};
`
